import React, { Component } from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import { createBrowserHistory } from "history";
import Preapps from "./components/Preapps";
import Header from "./components/preapps/Header";
import Login from "./components/login/login";
import Bank from "./components/bank/Bank";
import Organizations from "./components/organizations/organizations";
import EditOrganization from "./components/organizations/edit-organization/edit-organization";
import Dashboard from "./components/dashboard/dashboard-page";
import Residuals from "./components/residuals/residuals";
import { TrackJS } from "trackjs";
import UnprocessedResidual from "./components/residuals/unprocessed";
import PricingEquipment from "./components/pricing-equipment";
import CreateAppByLink from "./components/blank-app";
import ForgotPassword from "./components/forgot-password/forgot-password";
import ChangePassword from "./components/forgot-password/change-password";
import IdleTimerComponent from "./components/idle-timer/idle-timer";
import MerchantAppList from "./components/merchant-app-list";
import MccList from "./components/mcc/mcc-list";
import RetentionReport from "./components/report/report-one";
import { Logout, UserData } from "./api";
import CustomSignErrorModal from "./components/modals/custom-sign-error-modal/custom-sign-error-modal";
import config from "./config";
import Equipments from "./components/Equipments";
import MCCPage from "./v2/pages/mcc/index.jsx";
import Layout from "./v2/layout/Layout";
import ApplicationsPage from "./v2/pages/application/ApplicationPage.jsx";
import MerchantPage from "./v2/pages/merchant/MerchantPage.jsx";
import OrganizationsPage from "./v2/pages/organization";
import userStore from "./v2/stores/user";
import useSalesFormStore from "./v2/stores/sales-form";
import CreateAppPage from "./v2/pages/create-app/Index.jsx";
import PreApplication from "./v2/pages/create-app/PreApplication.jsx";
import ProcessorPage from "./v2/pages/processor/index.jsx";
import Templates from "./v2/pages/templates/index.jsx";
import CreateTemplate from "./v2/pages/templates/create";
import DashboardPage from "./v2/pages/dashboard/index.jsx";

class Routes extends Component {
  constructor(props) {
    super(props);
    TrackJS.addMetadata("Application", "Stratus");
    TrackJS.install({
      token: "fad66fce73f1425a9f24dfb6e69eaf99",
      application: "PaymentCloud",
    });

    this.state = {
      user: null,
      currentRoute: null,
      preAppCalled: 0,
      customSignErrorModal: false,
      is_ems_user: false,
    };
  }

  getPreAppData = () => {
    this.setState({ preAppCalled: this.state.preAppCalled + 1 });
  };

  logout() {
    Logout()
      .then((response) => {
        window.location = "/";
      })
      .catch((error) => console.log(error));
  }
  checkForSignaturePage = (response) => {
    if (
      response?.is_signature_submitted &&
      response?.is_signature_submitted === 1
    ) {
      this.setState({ customSignErrorModal: false });
    } else {
      if (response?.is_ems_user) {
        this.setState({ customSignErrorModal: true });
      } else {
        this.setState({ customSignErrorModal: false });
      }
    }
  };
  componentDidMount = () => {
    userStore.getState().setUserLoading(true);
    UserData().then((response) => {
      userStore.getState().setUser(response);
      userStore.getState().setUserLoading(false);
      useSalesFormStore.getState().setIsAuthenticated(true);
      this.setState({
        user: response,
        currentRoute: createBrowserHistory().location.pathname,
      });
      this.checkForSignaturePage(response);
      if (response?.is_ems_user) {
        this.setState({ is_ems_user: true });
      }
    });
  };
  refreshLogin = () => {
    userStore.getState().setUserLoading(true);
    UserData().then((response) => {
      this.setState({ user: response });
      userStore.getState().setUser(response);
      userStore.getState().setUserLoading(false);
      useSalesFormStore.getState().setIsAuthenticated(true);
      this.checkForSignaturePage(response);
      if (response?.is_ems_user) {
        this.setState({ is_ems_user: true });
      }
    });
  };

  tabShowActive(route) {
    this.setState({ currentRoute: route });
  }

  closeCustomSignErrorModal = () => {
    this.setState({ customSignErrorModal: false });
  };

  render() {
    const { user, is_ems_user } = this.state;
    return (
      <>
        <BrowserRouter>
          <Switch>
            {/* PreApplication route outside of Layout */}
            {this.state.user == null && (
              <Route
                exact
                path="/v2/application/:agent_url/:app_slug"
                component={PreApplication}
              />
            )}

            {/* Route for the new v2 namespace */}
            <Route path="/v2">
              <Layout>
                <Switch>
                  <Route
                    exact
                    path="/v2/applications"
                    component={ApplicationsPage}
                  />
                  <Route
                    exact
                    path="/v2/application/:agent_url/:app_slug"
                    component={PreApplication}
                  />
                  <Route
                    exact
                    path="/v2/create-app/:country"
                    component={CreateAppPage}
                  />
                  <Route exact path="/v2/merchants" component={MerchantPage} />
                  <Route
                    exact
                    path="/v2/mcc"
                    component={MCCPage}
                  />
                  <Route exact path="/v2/organizations" component={OrganizationsPage} />
                  <Route exact path="/v2/processors" component={ProcessorPage} />
                  <Route exact path="/v2/templates" component={Templates} />
                  <Route exact path="/v2/templates/create/:id?" component={CreateTemplate} />
                  <Route exact path="/v2/dashboard" component={DashboardPage} />

                  {/* <Route exact path="/v2/dashboard" component={Dashboard} /> */}
                  {this.state.user !== null && (
                    <Route
                      exact
                      path="/v2/create-pre-app"
                      component={PreApplication}
                    />
                  )}
                  {/* Add other /v2 routes here */}
                </Switch>
              </Layout>
            </Route>

            {this.state.user !== null ? (
              <>
                {user?.is_v2_enable == 1 ? (
                  <Layout>
                    <Switch>
                      <Route
                        exact
                        path="/applications"
                        component={ApplicationsPage}
                      />
                      <Route
                        exact
                        path="/application/:agent_url/:app_slug"
                        component={PreApplication}
                      />
                      <Route
                        exact
                        path="/create-app/:country"
                        component={CreateAppPage}
                      />
                      <Route exact path="/merchants" component={MerchantPage} />
                      <Route
                        exact
                        path="/mcc"
                        component={MCCPage}
                      />
                      <Route exact path="/organizations" component={OrganizationsPage} />
                      <Route exact path="/processors" component={ProcessorPage} />
                      <Route exact path="/templates" component={Templates} />
                      <Route exact path="/templates/create/:id?" component={CreateTemplate} />
                      <Route exact path="/dashboard" component={DashboardPage} />

                      {/* <Route exact path="/dashboard" component={Dashboard} /> */}
                      {this.state.user !== null && (
                        <Route
                          exact
                          path="/create-pre-app"
                          component={PreApplication}
                        />
                      )}
                      {/* Add other /v2 routes here */}
                    </Switch>
                  </Layout>
                ) : (
                  <div
                    className={`website-wrapper application-page organizationsPage ${this.state?.user?.organization_id == config.paymentcloud.PAYCHEX_ORG_ID ? "paychex" : is_ems_user ? "ems" : ""}`}
                  >
                    <Header
                      getPreAppData={this.getPreAppData.bind(
                        this,
                      )}
                      user={user}
                      onLogout={this.logout}
                      currentRoute={this.state.currentRoute}
                      tabShowActive={(route) =>
                        this.tabShowActive(route)
                      }
                    />
                    <Route
                      exact
                      path="/applications"
                      x="100"
                      render={(props) => (
                        <Preapps
                          user={user}
                          preAppCalled={
                            this.state.preAppCalled
                          }
                          {...props}
                          currentRoute={
                            this.state.currentRoute
                          }
                          tabShowActive={(route) =>
                            this.tabShowActive(route)
                          }
                        />
                      )}
                    />
                    <Route
                      exact
                      path="/app/:text"
                      component={Preapps}
                    />
                    <Route exact path="/bank" component={Bank} />
                    <Route
                      exact
                      path="/organization"
                      component={Organizations}
                    />
                    <Route
                      exact
                      path="/dashboard"
                      component={Dashboard}
                    />
                    <Route
                      exact
                      path="/residuals"
                      component={Residuals}
                    />
                    <Route
                      exact
                      path="/residuals/unprocessed"
                      component={UnprocessedResidual}
                    />
                    <Route
                      exact
                      path="/pricing-equipment"
                      component={PricingEquipment}
                    />
                    <Route
                      exact
                      path="/organization/:organization_id"
                      component={EditOrganization}
                    />
                    <Route
                      exact
                      path="/applications/:prevet_editslug"
                      component={Preapps}
                    />
                    <Route
                      exact
                      path="/create-blank-app/:org_slug/:agent_url/:template_id/:ems_office?"
                      component={CreateAppByLink}
                    />
                    <Route
                      exact
                      path="/merchants"
                      component={(props) => (
                        <MerchantAppList
                          {...props}
                          currentRoute={
                            this.state.currentRoute
                          }
                          tabShowActive={(route) =>
                            this.tabShowActive(route)
                          }
                        />
                      )}
                    />
                    <Route exact path="/mcc" component={MccList} />
                    <Route
                      exact
                      path="/equipments"
                      component={Equipments}
                    />
                    <Route
                      exact
                      path="/retention/report"
                      component={RetentionReport}
                    />
                  </div>
                )}
              </>
            ) : (
              <>
                <Route
                  exact
                  path="/"
                  component={(props) => (
                    <Login
                      {...props}
                      refreshLogin={this.refreshLogin}
                    />
                  )}
                />
                <Route
                  exact
                  path="/forgotPassword"
                  component={ForgotPassword}
                />
                <Route
                  exact
                  path="/changePassword/:token"
                  component={ChangePassword}
                />
                <Route
                  exact
                  path="/create-blank-app/:org_slug/:agent_url/:template_id/:ems_office?"
                  component={CreateAppByLink}
                />
              </>
            )}
          </Switch>
        </BrowserRouter>
        {this.state.customSignErrorModal && (
          <CustomSignErrorModal
            show={this.state.customSignErrorModal}
            closeModal={this.closeCustomSignErrorModal}
            data={this.state.user}
          />
        )}
        <IdleTimerComponent />
      </>
    );
  }
}
export default Routes;
